import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "feeDetail/";

// 我的申诉 - 列表
export const feeDetailPage = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "myPage", {
           data: _params,
           method: "GET"
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/feeDetail.js